import { getBridgeAPI } from '@databases/utils/database/bridge';

import { type Recyclable } from '../types.ts';

/**
 * Closes the Confluence side panel whenever the active database changes (SPA navigation between embeds).
 *
 * Replaces the `useEffect` in `services/databases/src/app/components/app.tsx` (~70–86) that tracked
 * `contentId` via a `useRef` and called `bridge.onCloseConfluenceSidePanel()` on change. Moving this
 * here keeps non-UI host-bridge calls out of the React tree and ensures they fire in a predictable,
 * ordered sequence alongside other identity recyclables.
 *
 * `setup` skips the initial load (`lastContentId === null`) to match the original effect's behaviour of
 * only acting on transitions, not first mount. Pass into {@link registerRecyclableModules}.
 */
export function createCloseConfluenceSidePanelRecyclable(): Recyclable {
  let lastContentId: string | null = null;

  return {
    setup(contentId: string) {
      if (lastContentId !== null && lastContentId !== contentId) {
        void (async () => {
          const bridge = await getBridgeAPI();
          await bridge?.onCloseConfluenceSidePanel?.();
        })();
      }

      lastContentId = contentId;
    },

    dispose() {},
  };
}
